import React from "react";

const Stats = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
        <path d="M12 13.3334V6.66669M8 13.3334V2.66669M4 13.3334V9.33335" stroke="#FF0009" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)

export default Stats